<ng-template cdkPortal #popup="cdkPortal">
  <div role="dialog" aria-label="Dialog" (click)="popupClick()" class="sonder-popup-dialog mat-typography">
    <a class="-close" (click)="changeState()">&times;</a>
    <ng-content></ng-content>
  </div>
</ng-template>
